<template>
  <div class="referred">
    <v-card-text>

      <div class="req-list">
        <div class="req-card"  v-for="item in list" :key="item.Id">
          <div>
            <div class="flex-no-wrap justify-space-between">
              <div @click="goToDetail(item)">
                <div
                  class="req-name"
                  v-text="item.BranchName"
                ></div>

                <span class="req-code">
                    <span class="bold">
                    {{ item.Summary }}
                    </span>
                  </span>
<!--                <span class="req-date">-->
<!--                    {{ item.DestBranchId }}-->
<!--                    <v-icon>-->
<!--                      mdi-calendar-range-->
<!--                    </v-icon>-->
<!--                  </span>-->

                <div>

                  <div class="status" >{{item.StatusName}}</div>

                </div>
              </div>

            </div>

          </div>

        </div>

      </div>

    </v-card-text>
    <v-btn color="primary" style="border-radius: 0px;" class="enter-btn footer_btn"  v-on:click="goToDetail()">{{ $t('addNewRequest') }}</v-btn>
  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        list: [],
        errors: [],
        selected_post: 0,
        selected_branch: 0,
        // request_items: [],
        // last_request_items: [],
        show_loading: false,
        no_info: true,
        page: 0,

        first: true,
      }
    },
    components: {
      InfiniteLoading,
    },
    watch: {

    },
    mounted () {
      this.get_factors()
      this.selected_post = parseInt(localStorage.getItem('selected_post'))
    },

    methods: {
      goToDetail (item) {
        if (item != null) {
          this.$router.push({ name: 'RequestGoodsItems', params: { rec_id: item.Id, cost_id:this.$route.params.rec_id } })
        } else {
          this.$router.push({ name: 'RequestGoodsItems', params: { rec_id: 0, cost_id:this.$route.params.rec_id } })
        }
      },
      get_factors () {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          CostCenterId: this.$route.params.rec_id,
        }

        console.log('pre request called')
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetGoodsReqByReqId', send_data, {})
          .then(response => {
            self.last_request_items = []
            if (response.data.error == 0) {
             self.list = response.data.items
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
